<template>
  <div class="topic">
    <!-- <div class="topic-title">{{ index + 1 }}、{{ content.name || '...' }}
        </div> -->
    <ul class="topic-list" v-if="paperList[index].type != 1">
      <template v-for="item in paperList[index].answers">
        <div :key="item.id">
          <div
            class="topic-list-item"
            @click="chooseItem(item)"
            :class="{ active: paperList[index].answerId.includes(item.id) }"
          >
            <div class="topic-list-item-text">
              {{ item.name }}
            </div>
            <div
              :class="
                paperList[index].type == 2
                  ? 'topic-list-item-checked'
                  : 'topic-list-item-radio'
              "
            ></div>
          </div>
          <div
            v-show="
              item.isRequired && paperList[index].answerId.includes(item.id)
            "
          >
            <VanInput
              :autofocus="true"
              :ref="'input-' + item.id"
              placeholder="请告诉我们您选择此选项的原因"
              type="text"
              v-model="paperList[index].content[item.id].remark"
            />
          </div>
        </div>
      </template>
    </ul>
    <ul class="topic-list" v-else>
      <template v-for="item in paperList[index].answers">
        <div :key="item.id">
          <div class="topic-list-item">
            <div class="topic-list-item-text">
              {{ item.name }}
            </div>
          </div>
          <div>
            <VanInput
              :autofocus="true"
              :ref="'input-' + item.id"
              placeholder="请在输入框中填写您的答案"
              type="text"
              v-model="paperList[index].content[item.id].remark"
            />
          </div>
        </div>
      </template>
    </ul>
  </div>
</template>

<script>
import { Field as VanInput } from "vant";
export default {
  props: {
    paperList: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  components: {
    VanInput,
  },
  data() {
    return {};
  },
  methods: {
    chooseItem(item) {
      // 聚焦
      if (item.isRequired) {
        setTimeout(() => {
          this.$refs["input-" + item.id][0].focus();
        }, 500);
      }
      this.$emit("chooseItem", item);
    },
  },
};
</script>

<style scoped lang="scss">
.topic {
  padding: 0.2rem 0;

  &-detail {
    font-size: 0.25rem;
    color: #666;
    padding: 0.2rem 0;
  }

  &-title {
    font-size: 0.25rem;
    color: #888;
    font-weight: bold;
  }

  &-list {
    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 0.02rem solid #eee;

      box-shadow: 3px 3px 7px rgba(0, 0, 0, .4), 1px 1px 1px rgba(255, 255, 255, .9);

      border-radius: 0.1rem;
      font-size: 0.25rem;
      color: #666;
      padding: 0.2rem 0.3rem;
      margin: 0.4rem 0;

      &-text {
        font-size: 0.25rem;
        color: #000;
      }

      &-radio {
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 50%;
        border: 1px solid #000;
        flex-shrink: 0;
      }
      &-checked {
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 0.05rem;
        border: 1px solid #000;
        flex-shrink: 0;
      }
    }

    .active {
      background-color: rgb(254, 248, 232);

      .topic-list-item-radio {
        background-color: rgb(255, 200, 55);
        flex-shrink: 0;
      }
      .topic-list-item-checked {
        background-color: rgb(255, 200, 55);
        flex-shrink: 0;
      }
    }
  }
}
</style>
